import { onValue, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { realtimeDB } from "../Backend";
import { Link } from "react-router-dom";

const UnitTuts = () => {

        const [tutorials,setTutorials]=useState([]);

        useEffect(()=>{
            onValue(ref(realtimeDB,"unitTuts"),(snapshot)=>{
                if(snapshot.exists()){
                    const tutSubData = snapshot.val();
                    const tutChildArray = Object.keys(tutSubData).map((key)=>({
                        id: key,
                        ...tutSubData[key],
                    }));
                    setTutorials(tutChildArray);
                }
            })
        },[]);




    return ( 
        <div className="unittuts flex-column2" >
            <h2>Tutorials for unit leaders</h2>
           
                {
                    tutorials && tutorials.map(data => (
                        <div className="unittutlist" key={data.id}>
                           
                            <div className="flex-column2" style={{width:"100%"}}>
                            <div className="unittutlisttitle flex-row2" style={{width:"100%",gap:"10px"}}>
                                <h3>{`${data.id}: ${data.title}`}</h3>
                                {
                                    data.download && 
                                    <a href={data.download}>
                                    <svg
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    height="2em"
                                    width="2em" >
                                    <path d="M12 16l4-5h-3V4h-2v7H8z" />
                                    <path d="M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z" />
                                    </svg>
                                </a>

                                }
                            
                            </div>
                            
                            <Link to={`/hghrptplayer/unitTuts/${data.title}/${data.id}`}>
                                <div className="tutimgthumbnail" style={{position:"relative",cursor:"pointer"}}>
                                    <img src={data.image} alt=""/>

                                    <div className="playsvg">
                                        <svg                           
                                        viewBox="0 0 24 24"
                                        fill="white"
                                        height="2em"
                                        width="2em">
                                        <path d="M7 6v12l10-6z" />
                                        </svg>
                                    </div>
                            
                                </div>
                            </Link>                        
                            </div>
                        </div>
                    ))
                }
        </div>
     );
} 
export default UnitTuts;